"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeAuthAdapter = void 0;
const auth_1 = require("@home-health-notify/auth");
/* eslint-disable @typescript-eslint/no-unused-vars */
class FakeAuthAdapter {
    constructor() {
        this.loggedIn = false;
    }
    login(loginData) {
        if (loginData.email === "bob@co.in" && loginData.password === "password") {
            this.loggedIn = true;
        }
        return Promise.resolve({
            isLoggedIn: this.loggedIn,
            passwordChangeRequired: false,
        });
    }
    getAccessToken() {
        if (this.loggedIn) {
            return Promise.resolve(new auth_1.AccessToken("token"));
        }
        return Promise.resolve(new auth_1.AccessToken(null));
    }
    isAuthenticated() {
        return Promise.resolve(this.loggedIn);
    }
    logOut() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.clearAuthSession();
        });
    }
    forgotPassword(email) {
        return Promise.resolve();
    }
    resetPassword(email, otp, newPassword) {
        return Promise.resolve();
    }
    setPassword(newPassword) {
        return Promise.resolve();
    }
    changePassword(oldPassword, newPassword) {
        return Promise.resolve();
    }
    clearAuthSession() {
        this.loggedIn = false;
        return Promise.resolve();
    }
    signOutFederated() {
        return this.clearAuthSession();
    }
    subscribeToCrossTabAuthChanges(_callback) {
        return () => undefined;
    }
    signInWithRedirect() {
        return Promise.resolve();
    }
    subscribeToSignInRedirectComplete(_callback) {
        return () => undefined;
    }
}
exports.FakeAuthAdapter = FakeAuthAdapter;
